/*
 * Module for the Direct Deposit Step of the MemberDirect Retirement Application wizard
*/
rs.module("content/benefits/retirementapplication/directdepositstep",

    [
        "common/select-helper",
        "controls/components/event-banner",
        "controls/navigation/wizard"
    ],

    function (selectHelper, eventBanner, wizard) {

        // Initialize the module
        function initialize(jsSelectors, backendUrls) {
            var stepContainer = $.js(jsSelectors.stepContainer);
            var form = stepContainer.closest("form");
            var abaInput = stepContainer.js(jsSelectors.abaInput);
            var abaHiddenInput = stepContainer.js(jsSelectors.abaHiddenInput);
            var verifyLoadingSpinner = stepContainer.js(jsSelectors.verifyLoadingSpinner);
            var verifyCheck = stepContainer.js(jsSelectors.verifyCheck);
            var bankSelector = stepContainer.js(jsSelectors.bankSelector);
            var bankSelectorContainer = stepContainer.js(jsSelectors.bankSelectorContainer);
            var bankSelectHelper = selectHelper.getHelper(bankSelector);
            var finInstitutionKeyHidden = stepContainer.js(jsSelectors.finInstitutionKeyHidden);
            var finInstitutionNameHidden = stepContainer.js(jsSelectors.finInstitutionNameHidden);
            var bankNameSpan = stepContainer.js(jsSelectors.bankNameSpan);
            var accountNumberTextBox = stepContainer.js(jsSelectors.accountNumberTextBox);
            var accountTypeSelect = stepContainer.js(jsSelectors.accountTypeSelect);
            var accountTypeSelectHelper = selectHelper.getHelper(accountTypeSelect);
            var verifyChangeButton = stepContainer.js(jsSelectors.verifyChangeButton);

            // Verify the routing number or reset the controls when clicked
            verifyChangeButton.click(function () {

                eventBanner.removeAllMessages();
                abaInput.clearErrors();
                bankSelector.clearErrors();
                finInstitutionKeyHidden.prop("disabled", true);
                bankNameSpan.html('');
                bankNameSpan.hide();

                accountNumberTextBox.clearErrors();
                accountTypeSelect.clearErrors();

                if (verifyChangeButton.text().trim() == "Verify") {

                    bankSelectHelper.setDisabled(false);
                    abaHiddenInput.val(abaInput.val());
                    verifyLoadingSpinner.show();

                    $.get(
                        {
                            url: backendUrls.getFinancialInstitutions,
                            headers: wizard.getNavigationToken(),
                            data: {
                                abaNumber: abaInput.val().trim()
                            }
                        }).always(function (){
                            verifyLoadingSpinner.hide();
                        }).done(function (options) {                            

                            if (options.length > 1) {
                                enableFormControls(false);
                                bankSelectHelper.replaceOptions(options, { withBlank: true });
                                showBankSelector(true);

                                abaInput.prop("disabled", true);
                                verifyChangeButton.text("Change");
                                verifyCheck.show();

                            } else if (options.length == 1) {
                                enableFormControls(true);
                                bankSelectHelper.replaceOptions(options);
                                showBankSelector(false);

                                abaInput.prop("disabled", true);
                                verifyChangeButton.text("Change");
                                verifyCheck.show();
                                eventBanner.removeAllMessages(); //remove the message about multiple banks if it is shown
                                bankSelectHelper.setValue(options[0].value); //there is only one option, so set the value for the selector
                                finInstitutionKeyHidden.prop("disabled", false);
                                finInstitutionKeyHidden.val(options[0].value);
                                finInstitutionNameHidden.val(options[0].text);
                                bankNameSpan.html(options[0].text); // show the bank name
                                bankNameSpan.show();

                            } else if (options.length == 0) {
                                enableFormControls(false);
                                bankSelectHelper.clearOptions();
                                showBankSelector(false);

                                abaInput.prop("disabled", false);
                                verifyChangeButton.text("Verify");
                                verifyCheck.hide();
                                bankSelectHelper.setValue(null);
                            }
                        });
                } else if (verifyChangeButton.text().trim() == "Change") {
                    enableFormControls(false);
                    bankSelectHelper.clearOptions();
                    showBankSelector(false);

                    abaInput.prop("disabled", false);
                    verifyChangeButton.text("Verify");
                    verifyCheck.hide();
                    eventBanner.removeAllMessages(); //remove the message about multiple banks if it is shown
                    $.validator.resetValidation(form); //reset the error message for the bank selector if shown
                }
            });

            // enable/disable form controls depending on the validity of the aba number
            function enableFormControls(enable) {

                accountNumberTextBox.prop("disabled", !enable);
                accountTypeSelectHelper.setDisabled(!enable);
            }

            // show or hide the bank drop down selector
            function showBankSelector(show) {
                if (show) {
                    abaInput.addClass("dropdown-shown");
                    verifyChangeButton.addClass("dropdown-shown");
                    bankSelectorContainer.slideDown();
                } else { 
                    abaInput.removeClass("dropdown-shown");
                    verifyChangeButton.removeClass("dropdown-shown");
                    bankSelectorContainer.slideUp();
                }
            }

            // enable/disable form controls based on the bank selection
            bankSelector.change(function () {
                finInstitutionNameHidden.val(bankSelector.find(":selected").text());
                enableFormControls(bankSelector.val() != "");
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);